var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCardElo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 48,
    viewBox: "0 0 76 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.566406,
    width: 74.4348,
    height: 48,
    rx: 5,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3521 20.6398L14.6498 25.7035C14.6315 25.4991 14.6221 25.294 14.6218 25.0888C14.6218 21.3718 17.6223 18.359 21.3239 18.359C23.3268 18.359 25.1241 19.2415 26.3521 20.6398ZM21.3239 13.3261C26.846 13.3261 31.4748 17.1628 32.7126 22.3259L27.9914 24.3986L27.9902 24.3888L23.1596 26.5196L11.5721 31.6073C10.289 29.6777 9.60584 27.4089 9.60939 25.0888C9.60939 18.5924 14.854 13.3261 21.3239 13.3261ZM29.5097 33.5032C25.3155 37.5003 19.7663 37.8926 14.8907 34.9205L17.6456 30.7148C20.4199 32.38 23.2073 32.11 26.0073 29.9026L29.5097 33.5029V33.5032ZM34.2798 30.5912L34.25 8.34766H38.4473V29.9909C38.4473 30.1983 38.4729 30.3811 38.7441 30.4871L42.3953 31.9128L40.7503 36.2074L36.4732 34.3905C34.8515 33.7013 34.2825 32.7029 34.2795 30.5912H34.2798Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0823 30.2168C48.5092 28.9882 47.4961 27.0714 47.4961 24.9154C47.4961 22.9989 48.2972 21.2712 49.5804 20.048L46.8695 15.6367C44.1444 17.8044 42.3945 21.1538 42.3945 24.9154C42.3945 28.9703 44.4261 32.5472 47.522 34.6801L50.0823 30.2168Z",
    fill: "#2091C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9206 18.5992C52.6463 18.3372 53.4117 18.2035 54.1829 18.2041C57.0451 18.2041 59.4862 20.0114 60.4397 22.5508L65.6342 22.115C64.3803 16.9316 59.7306 13.082 54.1829 13.082C52.6639 13.081 51.1592 13.3758 49.752 13.9499L51.9206 18.5992Z",
    fill: "#FAEC32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.861 25.2422C60.6917 28.7988 57.7672 31.6302 54.1834 31.6302C53.6215 31.6302 53.0764 31.5593 52.5554 31.4285L50.5176 36.1657C51.7011 36.5546 52.9384 36.7525 54.1837 36.7523C60.5308 36.7523 65.7036 31.714 65.9581 25.4035L60.861 25.2422Z",
    fill: "#D0352A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardElo);
export default __webpack_public_path__ + "static/media/icon-card-elo.8b8f846f4cd1a64d6702252912158a1b.svg";
export { ForwardRef as ReactComponent };